import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { AppPagination } from '@/shared/ui/pagination'
import { useState } from 'react'
import { goToTopUpSteam } from '@/app/routing/events'
import { goToMain } from '@/app/routing/events'
import { $transactionHistoryQuery } from '@/entities/payments/store'
export const TransactionHistoryView = () => {
  const userLang = useUnit($userLanguage)
  const to = useUnit($transactionHistoryQuery)

  useHideNav()

  const texts = lang[userLang].pages.transactionHistory
  const { classes } = useStyles()
  const [currentPage, setCurrentPage] = useState(1)

  useBackButton({
    onBack: () => {
      if (to === 'topUpSteam') {
        goToTopUpSteam()
      } else {
        goToMain()
      }
    },
  })

  return (
    <div className={classes.root}>
      <h1>{texts.heading}</h1>
      <AppPagination
        onChange={() => setCurrentPage(currentPage + 1)}
        count={12}
      />
    </div>
  )
}
